import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

function Dashboard({ perfil }) {
  const [stats, setStats] = useState({ total: 0, pendientes: 0, enProgreso: 0, finalizados: 0 });
  const [ultimosRecibos, setUltimosRecibos] = useState([]);
  const [ultimasCapacitaciones, setUltimasCapacitaciones] = useState([]);
  const [proximoCobro, setProximoCobro] = useState(null);

  useEffect(() => {
    cargarStats();
    cargarRecibos();
    cargarCapacitaciones();
    calcularProximoCobro();
  }, []);

  async function cargarStats() {
    const { data } = await supabase.from('trabajos').select('estado');
    if (data) {
      setStats({
        total: data.length,
        pendientes: data.filter(t => t.estado === 'pendiente').length,
        enProgreso: data.filter(t => t.estado === 'en progreso').length,
        finalizados: data.filter(t => t.estado === 'finalizado').length,
      });
    }
  }

  async function cargarRecibos() {
    const { data } = await supabase
      .from('recibos')
      .select('*')
      .eq('empleado_id', (await supabase.auth.getUser()).data.user?.id)
      .order('created_at', { ascending: false })
      .limit(3);
    setUltimosRecibos(data || []);
  }

  async function cargarCapacitaciones() {
    const { data } = await supabase
      .from('capacitaciones')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(3);
    setUltimasCapacitaciones(data || []);
  }

  function calcularProximoCobro() {
    const hoy = new Date();
    const año = hoy.getFullYear();
    const mes = hoy.getMonth();

    const feriados2026 = [
      '2026-01-01', // Año Nuevo
      '2026-02-16', // Carnaval
      '2026-02-17', // Carnaval
      '2026-03-23', // Feriado puente
      '2026-03-24', // Día de la Memoria
      '2026-04-02', // Día del Veterano
      '2026-04-03', // Viernes Santo
      '2026-05-01', // Día del Trabajador
      '2026-05-25', // Día de la Patria
      '2026-06-15', // Feriado puente
      '2026-06-20', // Paso a la Inmortalidad de Belgrano
      '2026-07-09', // Día de la Independencia
      '2026-08-17', // Paso a la Inmortalidad de San Martín
      '2026-10-12', // Día del Respeto a la Diversidad Cultural
      '2026-11-20', // Día de la Soberanía Nacional
      '2026-11-23', // Feriado puente
      '2026-12-08', // Inmaculada Concepción
      '2026-12-25', // Navidad
    ];

    function esFeriado(fecha) {
      const str = fecha.toISOString().split('T')[0];
      return feriados2026.includes(str);
    }

    function esDiaHabil(fecha) {
      const dia = fecha.getDay();
      if (dia === 0 || dia === 6) return false;
      return !esFeriado(fecha);
    }

    function cuartoDiaHabil(desde) {
      let fecha = new Date(desde);
      fecha.setDate(fecha.getDate() - 1); // empezamos desde el día anterior al 1 o 16
      let contados = 0;
      while (contados < 4) {
        fecha.setDate(fecha.getDate() + 1);
        if (esDiaHabil(fecha)) contados++;
      }
      return fecha;
    }

    // Quincena 1: 4to día hábil a partir del 1
    const cobro1 = cuartoDiaHabil(new Date(año, mes, 1));

    // Quincena 2: 4to día hábil a partir del 16
    const cobro2 = cuartoDiaHabil(new Date(año, mes, 16));

    // Próximo mes quincena 1
    const cobro3 = cuartoDiaHabil(new Date(año, mes + 1, 1));

    const hoyInicio = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());

    let proximo = null;
    if (hoyInicio <= cobro1) proximo = cobro1;
    else if (hoyInicio <= cobro2) proximo = cobro2;
    else proximo = cobro3;

    setProximoCobro(proximo);
  }

  const diasRestantes = proximoCobro
    ? Math.ceil((proximoCobro - new Date()) / (1000 * 60 * 60 * 24))
    : null;

  const formatFecha = (f) => new Date(f).toLocaleDateString('es-AR', {
    weekday: 'long', day: 'numeric', month: 'long'
  });

 return (
    <div className="dashboard">
      <div className="dashboard-bienvenida">
        <h1>👋 Bienvenido, {perfil?.nombre?.split(' ')[0] || 'Usuario'}</h1>
        <p>{perfil?.cargo}</p>
      </div>

      {proximoCobro && (
        <div className="cobro-card">
          <div className="cobro-icono">💰</div>
          <div className="cobro-info">
            <div className="cobro-titulo">Próximo día de cobro</div>
            <div className="cobro-fecha">{formatFecha(proximoCobro)}</div>
            <div className="cobro-dias">
              {diasRestantes === 0 ? '¡Hoy es día de cobro!' :
               diasRestantes === 1 ? 'Mañana' :
               `Faltan ${diasRestantes} días`}
            </div>
          </div>
        </div>
      )}

      <div className="dashboard-card">
        <div className="dashboard-seccion-titulo">🗺️ Estado de obras</div>
        <div className="stats-grid">
          <div className="stat-card stat-total">
            <div className="stat-numero">{stats.total}</div>
            <div className="stat-label">Total</div>
          </div>
          <div className="stat-card stat-pendiente">
            <div className="stat-numero">{stats.pendientes}</div>
            <div className="stat-label">Pendientes</div>
          </div>
          <div className="stat-card stat-progreso">
            <div className="stat-numero">{stats.enProgreso}</div>
            <div className="stat-label">En progreso</div>
          </div>
          <div className="stat-card stat-finalizado">
            <div className="stat-numero">{stats.finalizados}</div>
            <div className="stat-label">Finalizados</div>
          </div>
        </div>
      </div>

      <div className="dashboard-card">
        <div className="dashboard-seccion-titulo">📄 Últimos recibos</div>
        {ultimosRecibos.length === 0
          ? <p className="dashboard-vacio">No tenés recibos cargados todavía.</p>
          : ultimosRecibos.map(r => (
            <a key={r.id} href={r.url} target="_blank" rel="noreferrer" className="dashboard-item">
              <span>📄 {r.periodo}</span>
              <span className="dashboard-item-fecha">
                {new Date(r.created_at).toLocaleDateString('es-AR')}
              </span>
            </a>
          ))
        }
      </div>

      <div className="dashboard-card">
        <div className="dashboard-seccion-titulo">📚 Últimas capacitaciones</div>
        {ultimasCapacitaciones.length === 0
          ? <p className="dashboard-vacio">No hay capacitaciones cargadas todavía.</p>
          : ultimasCapacitaciones.map(c => (
            <a key={c.id} href={c.url} target="_blank" rel="noreferrer" className="dashboard-item">
              <span>📚 {c.titulo}</span>
              <span className="dashboard-item-fecha">
                {new Date(c.created_at).toLocaleDateString('es-AR')}
              </span>
            </a>
          ))
        }
      </div>
    </div>
  );
}

export default Dashboard;